(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, $) {
    'use strict';
    // ==================================================
    // Manejador de eventos step
    // ==================================================  
    Handler.stepHandler = function (step, o) {
        switch (step) {
            case 'combo_procesar':
                /* Stats */
                Model.setCombo(o.data('combo'));
                if (!Helper.isEmpty(Model.PlanElegido) && o.data('combo') != Config.COMBO_BONIFICADO) {
                    Analytics.clickCombo(Model.PlanElegido.nombre, Model.PlanElegido.precio, Helper.getSource());
                }
                if (o.data('combo') == Config.COMBO_BONIFICADO) {
                    Analytics.clickCombo3(Helper.getSource());
                }
                /* /Stats */
                Controller.inicio(o.data('combo'));
                break;
            case 'ingresar_dni':
                Controller.ingresarDni();
                break;
            case 'formulario_datos_personales':
                //Controller.formularioDatosPersonales();
                Controller.ingresarDni();
                break;
            case 'formulario_envio':
                //Controller.formularioEnvio();
                Controller.posdatarDomicilio();
                break;

            case 'aceptar_terminos':
                //LN.AppEvent.sendEvent('CERRO');
                Controller.aceptaTyC();                             // Ejecuta compra impl�cita de Combo 3 
                break;
            case 'agregar_domicilio':
                Controller.agregarDomicilio();
                break;
            case 'logout':
                Service.logout();
                LN.AppEvent.sendEvent('LOGINTO');
                break;
            case 'volver_inicio':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                
                /*if (Helper.getSource() == 'wall' || Helper.getSource() == 'suscripcion') {
                    if (Model.Window.modo == 'V' && Model.Window.combo == 2)
                      View.pdfSinSuscripcion();
                    else
                        View.wall();
                }
                else {
                    if (Helper.getSource() == 'wall_suscribirme')
                        View.wallSuscribime();
                    else
                        View.landing();
                }*/
                if (Model.refWall) {
                    location.href = Model.refWall;
                    return;
                }

                switch (Helper.getSource()) {
                    case 'wall':
                    case 'suscripcion':
                    case 'wall_cerrado':
                        {
                            if (Model.Window.modo == 'V' && Model.Window.combo == 2)
                                View.pdfSinSuscripcion();
                            else
                                View.wall();
                        }
                        break;
                    case 'wall_suscribirme':
                        View.wallSuscribime();
                        break;
                    default:
                        View.wall();
                }
                break;
            case 'volver_edicion_impresa':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack({
                    url: Config.urlEdicionImpresa
                });
                break;
            case 'volver_formulario_datos_personales':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                View.formularioDatosPersonales();
                break;
            case 'domicilio_usar_nuevo':
                Helper.hideModalAddress();
                break;
            case 'domicilio_usar_seleccionado':
                Model.DomicilioElegido.id = Helper.checkIfAddressExist(Model.DomicilioTemp);
                Helper.selectAddressRadio(Model.DomicilioElegido.id);
                Helper.hideModalAddress();
                break;
            case 'volver_ingresar_dni':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Controller.flowC();
                break;
            case 'quick_view':
                // Solo con propositos de testing
                eval("LN.View." + o.data('view') + "()");
                break;
            case 'asociar_tarjeta_corto':
                Controller.asociarCredencialCorto();                // Asociar corto
                break;
            case 'asociar_tarjeta_largo':
                Controller.asociarCredencialLargo();                // Asociar largo
                break;
            case 'ya_tenes_suscripcion':
                Analytics.clickYaTengoSuscripcion();
                Model.ComboAccesoSuscripcion = true;
                Service.isLogged(function () {
                    Controller.flowA(Config.defaultModo, Config.defaultCombo);
                }, function () {
                    Helper.redirectToLoginWAction(Config.ACCION_YA_TIENE_SUSCRIPCION);
                });
                break;
            case 'return_back':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack();
                LN.AppEvent.sendEvent('CERRO');
                break;
            case 'return_back_front':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack({
                    url: Config.defaultRedirectUrl
                });
                break;
            case 'volver':
                Analytics.otrosEnlaces(Helper.getSource(), 'volver');
                Helper.returnBack({
                    url: document.referrer
                });
                break;
            case 'validar_pines_activar':
                Controller.validarPinesProcesar();
                break;
            case 'validar_pines_tyc':
                Controller.validarPinesTyC();
                break;
            case 'validar_pines_miclub':
                Controller.validarPinesMiClub();
            case 'validar_pines_reenviar':
                Controller.validarPinesReenviar();
                break;
            case 'redirect':
                Helper.redirectUrl(o.data('url'));
            case 'callback-mobile':
                LN.AppEvent.sendEvent(o.data('callback'), o.attr('href'));
            default:
        }
    }

})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/stepHandler.js